export default "__VITE_ASSET__CJHHTWdC__"